import React, { ReactElement } from 'react';
import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import mapDate from '../../../function/mapDate';

interface Props {
  filter: PrispevokVestnikaListFilter;
  onUpdateField: SafeParameterSetter<PrispevokVestnikaListFilter>;
  className?: string;
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void;
}

const putDatumyOdDoToArray = (
  datumOd: Date,
  datumDo: Date,
): string[] => {
  if (datumOd && datumDo) {
    return [`od ${mapDate(datumOd)}`,
      `do ${mapDate(datumDo)}`];
  }
  if (datumOd) {
    return [`od ${mapDate(datumOd)}`];
  }
  if (datumDo) {
    return [`do ${mapDate(datumDo)}`];
  }
  return [];
};

const FilterTagsComponent = ({
  filter,
  onUpdateField,
  className = '',
  onClearFilters = null,
}: Props): ReactElement => {
  const classes: string = classNames('vestniky-filter-tag-component', className);

  return (
    <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
      <FilterTag
        title="Rezort"
        data={filter.rezort?.nazov}
        onClear={() => onUpdateField('rezort', null)}
      />
      <FilterTag
        title="Hľadaný výraz"
        data={filter.searchTextVyraz}
        onClear={() => {
          onUpdateField('searchTextVyraz', '');
        }}
      />
      <FilterTag
        title="Názov príspevku"
        data={filter.searchTextNazov}
        onClear={() => {
          onUpdateField('searchTextNazov', '');
        }}
      />
      <FilterTag
        title="Číslo príspevku"
        data={filter.searchTextCislo}
        onClear={() => {
          onUpdateField('searchTextCislo', '');
        }}
      />
      <FilterTag
        title="Ročník"
        data={filter.searchTextRocnik}
        onClear={() => {
          onUpdateField('searchTextRocnik', '');
        }}
      />
      <FilterTag
        title="Dátum účinnosti"
        data={putDatumyOdDoToArray(filter.datumUcinnostiOd, filter.datumUcinnostiDo)}
        onClear={(title) => {
          if (title.startsWith('od')) {
            onUpdateField('datumUcinnostiOd', null);
          }
          if (title.startsWith('do')) {
            onUpdateField('datumUcinnostiDo', null);
          }
        }}
      />
      <FilterTag
        title="Dátum zverejnenia"
        data={putDatumyOdDoToArray(filter.datumZverejneniaOd, filter.datumZverejneniaDo)}
        onClear={(title) => {
          if (title.startsWith('od')) {
            onUpdateField('datumZverejneniaOd', null);
          }
          if (title.startsWith('do')) {
            onUpdateField('datumZverejneniaDo', null);
          }
        }}
      />
    </FilterTagGroup>
  );
};

export default FilterTagsComponent;
